import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material";

const ReviewEmptyState = ({ title, message, showButton = false, buttonText, onButtonClick }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        borderRadius: "12px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        border: "1px solid #E8EAED",
      }}
      variant="outlined"
    >
      <CardContent sx={{ textAlign: "center", py: 8, px: 4 }}>
        <WarningIcon
          sx={{
            fontSize: 40,
            color: theme.customColors?.text?.secondary || "#6B7280",
            mb: 2,
          }}
        />
        <Typography
          variant="h5"
          sx={{
            mb: 1,
            color: theme.customColors?.text?.secondary || "#6B7280",
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            mb: 3,
            color: theme.customColors?.text?.secondary || "#6B7280",
          }}
        >
          {message}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ReviewEmptyState;

